import React from "react";
import { Control, useController } from "react-hook-form";
import "./Switch.scss";

export type SwitchProps = {
	control: Control<any>;
	name: string;
	colorOne: string;
	colorTwo: string;
	disabled?: boolean;
};

const Switch: React.FC<SwitchProps> = ({
	control,
	name,
	colorOne,
	colorTwo,
	disabled,
}) => {
	const { field } = useController({
		name,
		control,
		defaultValue: false,
	});
	return (
		<>
			<input
				className="switch-checkbox"
				id={`switch-${name}`}
				type="checkbox"
				disabled={disabled}
				{...field}
			/>
			<label
				style={
					{
						"--switch-bg": field.value ? colorOne : colorTwo,
					} as React.CSSProperties
				}
				className="switch-label"
				htmlFor={`switch-${name}`}
			>
				<span
					className={`${
						disabled ? "switch-button-inactive" : "switch-button-active"
					} switch-button`}
				></span>
			</label>
		</>
	);
};

export default Switch;
